const doc = [({"en":({"js":({"users":({"notifications":({"partial":({"mark_as_read":"Mark as read", "mark_all_as_read":"Mark all as read"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;